import { createLink } from '@tanstack/react-router'

import { logout } from '@/backend/authentication'
import { useCurrentUser } from '@/services/users'

import { AnchorButton, Button, Icon, MenuButton } from '@/libraries/ui'
import { useT } from '@/i18n'
import { useDimensionCssVariables } from '@/utils/useDimensionCssVariables'

import { NavigateButton } from './widgets/NavigateButton'

function Navigation() {
  const ref = useDimensionCssVariables('page-navbar')
  const T = useT('')

  return <nav ref={ref} className="flex relative z-10 flex-wrap justify-between items-center px-3.5 h-auto bg-white shadow-sm min-h-12.5 shadow-stone-600/30 print:hidden">
    <NavButton
      icon={<img className="mr-1 size-8" src="/fan48.webp" alt="" />}
      text={T('app.title')}
      to="/"
    >
    </NavButton>
    <div className="flex items-center">
      <NavButton
        requireRight="dances:list"
        icon={<span className="mr-0.5">💃</span>}
        to="/dances"
        text={<span className="max-[450px]:sr-only">{T('navigation.dances')}</span>}
        tooltip={T('navigation.dances')}
      />
      <div className="self-stretch mx-1 w-px bg-stone-300" />
      <LoginStatus />
    </div>
  </nav>
}

const NavButton = createLink((props: React.ComponentProps<typeof AnchorButton>) => <AnchorButton minimal {...props} className="" />)

function LoginStatus() {
  const user = useCurrentUser()
  const t = useT('navigation')

  if (user) {
    return <span>
      <MenuButton
        buttonRenderer={props =>
          <Button
            minimal
            icon={<Icon icon="person" className="mr-0.5 text-amber-600 mt-px" />}
            text={user.name}
            iconOnly
            {...props}
          />
        }
      >
        <MenuButton.ItemLink to="/users" text={t('userSettings')} />
        <MenuButton.ItemLink to="/volunteers" text={t('volunteers')} />
        <MenuButton.ItemLink to="/ballrooms" text={t('ballrooms')} />
        <MenuButton.ItemButton onClick={logout} text={t('logout')} />
      </MenuButton>
    </span>
  }

  return <NavigateButton
    minimal
    to="/login"
    icon={<Icon icon="person" className="text-stone-500 mt-px" />}
    text={<span className="max-[450px]:sr-only">{t('login')}</span>}
  />
}

export default Navigation
